export const MAIN_PAGE_ROUTE = '/';
export const LOGIN_PAGE_ROUTE = '/login';
export const LOGOUT_PAGE_ROUTE = '/logout';
export const PASSWORD_RESET_ROUTE = '/login/recovery/:code';
export const OTP_PAGE_ROUTE = '/login/mfa';
export const REDIRECT_EXTERNAL_LOGIN_ROUTE = '/login/redirect';
export const FORGOT_PASSWORD_ROUTE = '/login/forgot';
export const GDPR_ACCESS_ROUTE = '/login/gdpr/:id';
export const CHAT_PAGE_ROUTE = '/conversations';
export const PREVIEW_PAGE_ROUTE = '/preview';
export const REPORTS_PAGE_ROUTE = '/reports';
export const REVISIONS_PAGE_ROUTE = '/revisions';
export const DASHBOARD_PAGE_ROUTE = '/dashboard';
export const DESIGNER_PAGE_ROUTE = '/designer';
export const EXPORTS_PAGE_ROUTE = '/exports';
export const SETTINGS_PAGE_ROUTE = '/settings';
export const ACCOUNT_PAGE_ROUTE = '/account';
export const ACTIVITY_LOGS_PAGE_ROUTE = '/logs';
export const NEW_CUSTOMER_ROUTE = '/customers/create';
export const SELECT_CUSTOMER_ROUTE = '/customers';
export const PROVISION_STATUS_ROUTE = '/customers/:companyId/provision';
export const PRIVACY_POLICY_ROUTE = '/privacy';
export const COOKIE_POLICY_ROUTE = '/cookie-policy';
export const TERMS_AND_CONDITIONS_ROUTE = '/terms';
export const GDPR_PAGE_ROUTE = '/gdpr';
export const MFA_ENFORCED_BY_COMPANY_ROUTE = '/login/set-mfa';
export const TAILWIND_PAGE_COMPONENTS = '/tailwind/demo';
export const TRAIN_AI_PAGE_ROUTE = '/train-ai';
export const AI_KNOWLEDGE_HUB_PAGE_ROUTE = '/ai-knowledge-hub';
export const ARTICLE_ARCHITECT_PAGE_ROUTE = '/article-architect';
export const ARTICLE_ARCHITECT_CONFLICTS_ROUTE = `${ARTICLE_ARCHITECT_PAGE_ROUTE}/conflicts`;
export const ARTICLE_ARCHITECT_REVIEW_ROUTE = `${ARTICLE_ARCHITECT_PAGE_ROUTE}/review`;
export const ARTICLE_ARCHITECT_GENERATION_ROUTE = `${ARTICLE_ARCHITECT_PAGE_ROUTE}/generation`;
export const INTEGRATIONS_PAGE_ROUTE = '/integrations';
export const EDIT_APPEARANCE_PAGE_ROUTE = '/edit-appearance';
export const CONFIGURATION_PAGE_ROUTE = '/configuration';
export const TEST_ACCURACY_PAGE_ROUTE = '/test-accuracy';
export const HOME_PAGE_ROUTE = '/home';
export const VOICE_AI_PAGE_ROUTE = '/voice-ai';
export const AI_TICKET_DEFLECTION_ROUTE = '/ai-ticket-deflection';
export const TEMPLATE_RESPONSES_PAGE_ROUTE = '/template-responses';
export const USERS_PAGE_ROUTE = '/users';

// Settings specific
export const SETTINGS_PAGE_BOT_GENERAL_ROUTE = `${SETTINGS_PAGE_ROUTE}/bot-settings/app-settings`;
export const SETTINGS_PAGE_WEBCLIENT_CONFIG_ROUTE = `${SETTINGS_PAGE_ROUTE}/integrations/webclient`;
export const SETTINGS_PAGE_EMAIL_STUDIO_ROUTE = `${SETTINGS_PAGE_ROUTE}/integrations/email-studio`;
export const SETTINGS_PAGE_VOICE_STUDIO_ROUTE = `${SETTINGS_PAGE_ROUTE}/integrations/voice-studio`;
export const SETTINGS_PAGE_REVISIONS_MANAGER = `${SETTINGS_PAGE_ROUTE}/revisions/manage`;
export const SETTINGS_PAGE_DEBUG_OPTIONS = `${SETTINGS_PAGE_ROUTE}/bot-settings/debug-settings`;
export const SETTINGS_PAGE_ROLES_MANAGER = `${SETTINGS_PAGE_ROUTE}/platform-settings/roles`;

// Train AI specific
export const TRAIN_AI_WEEKLY_OVERVIEW_ROUTE = '/weekly-overview';
export const TRAIN_AI_CONVERSATION_LISTING_ROUTE = '/conversation-listing';
export const TRAIN_AI_DUPLICATE_QUESTION_LISTING_ROUTE =
  '/duplicate-question-listing';
export const TRAIN_AI_HOT_TOPIC_CONVERSATION_LISTING_ROUTE =
  '/hot-topic-conversation-listing';
